import React from 'react';
import { Card, CardHeader, CardContent, CardActions, Button, Grid, CircularProgress } from '@material-ui/core';
import { SimpleFileUpload, TextField } from 'formik-material-ui';
import { Formik, Form, Field } from 'formik';
import { addFieldForm } from 'utils/ProjectConfigurationUtil';
import { useAppContext } from 'hooks/useAppContext';

const AddFieldForm = ({ callback: submitCallback }) => {
  const { selectedProject } = useAppContext();

  const validate = (values) => {
    const errors = {};
    if (!values.value) {
      errors.value = 'File is Required';
    };
    if (values.TestType.length === 0) {
      errors.TestType = 'File Type is Required';
    };
    return errors;
  };

  const onSubmit = async (values, actions) => {
    values.ProjectId = selectedProject;
    const result = await addFieldForm(values);
    actions.setSubmitting(false);
    if (result.success) {
      actions.resetForm();
      submitCallback();
    }
  }

  return (
    <Grid container justify="center" style={{ padding: 16 }}>
      <Card>
        <Formik
          validate={validate}
          initialValues={{
            value: null,
            TestType: '',
            Description: ''
          }}
          onSubmit={onSubmit}
        >
          {(params) => {
            return (
              <>
                {
                  !params.isSubmitting ? <Form>
                    <CardHeader id="form-Card-title" title="Add Field Form"></CardHeader>
                    <CardContent>
                      <Field
                        component={SimpleFileUpload}
                        name="value"
                        label="Upload a file"
                        onChange={(event) => {
                          params.setFieldValue("value", event.currentTarget.files[0])
                        }}
                      />
                      <Field
                        component={TextField}
                        label="Description"
                        name="Description"
                        style={{ width: "100%" }}
                      />
                      <Field
                        component={TextField}
                        label="Form Test Type"
                        name="TestType"
                        style={{ width: "100%" }}
                      />
                    </CardContent>
                    <CardActions>
                      <Button color="primary" type="submit" variant="contained"> Upload Field Form</Button>
                    </CardActions>
                  </Form> : <CircularProgress></CircularProgress>
                }
              </>
            )
          }}
        </Formik>
      </Card>
    </Grid>
  )
}

export default AddFieldForm;